import { useEffect, useState }  from "react";
import { FaTimes, FaEdit, FaCheck } from 'react-icons/fa';

const ListWithControls = ({ items, selected, fxSelectItem, fxRenameItem, fxDeleteItem, itemToRename, fxSetItemToRename }) => {

    const selectItemToRename = (e, item) => {
        e.stopPropagation();
        fxSetItemToRename(item);
    }

    const handleItemNameChange = (e, item) => {
        e.stopPropagation();
        fxSetItemToRename({ ...item, name: e.target.value });
    }

    const dismissRenameItem = e => {
        e.stopPropagation();
        fxSetItemToRename(null);
    }

    const listClasses = id => {
        const common = 'flex items-center p-2 border-b border-gray-700';
        const specific = selected?.id == id ?
            "bg-gray-700 text-white" : "cursor-pointer hover:bg-gray-700";
        return `${common} ${specific}`;
    }

    return (
        <ul style={{ maxHeight: 500, overflowY: "auto" }}>
        { 
            items.map(
                item => itemToRename?.id == item.id ?
                <li className={listClasses(item.id)} key={ item.id } onClick={() => fxSelectItem(item)}>
                    <input style={{width: 200}} className="p-2 text-white bg-gray-700 border border-gray-600" type="text" value={ itemToRename.name } onClick={e => e.stopPropagation()} onChange={e => handleItemNameChange(e, item)} />
                    <button className="ml-2 p-1 text-gray-300 hover:text-white rounded border border-gray-600 hover:bg-green-500" 
                        onClick={e => fxRenameItem(e, item)}>
                        <FaCheck />
                    </button>
                    <button className="ml-auto p-1 text-gray-300 hover:text-white rounded border border-gray-600 hover:bg-yellow-500" 
                        onClick={e => dismissRenameItem(e)}>
                        <FaTimes />
                    </button>
                </li>
                :
                <li className={listClasses(item.id)} key={ item.id } onClick={() => fxSelectItem(item)}>
                    { item.name } [{ item.id }] 
                    <button className="ml-auto p-1 text-gray-300 hover:text-white rounded border border-gray-600 hover:bg-green-500" 
                        onClick={e => selectItemToRename(e, item)}>
                        <FaEdit />
                    </button>
                    <button className="ml-2 p-1 text-gray-300 hover:text-white rounded border border-gray-600 hover:bg-yellow-500" 
                        onClick={() => fxDeleteItem(item)}>
                        <FaTimes />
                    </button>
                </li>
            ) 
        }
        </ul>
    );
}

export default ListWithControls;